import React, { Fragment, memo, useEffect, useState } from 'react'
import styles from './SelectedListItem.module.scss'
import ToggleButton from '../../toggle-button/ToggleButton'

type Props = {
    item?: any
    buttonTitle?: string
    onBackHandler?: () => void
    toggleButtonHandler?: () => void
}

const SelectedListItem: React.FC<Props> = memo((props: Props) => {
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: '2-digit', year: 'numeric' };
    const [ isOwner, setIsOwner ] = useState(props.item.type === 'Owner'); 
    const [ statusClass, setStatusClass ] = useState<string>(''); 
    const [ item, setItem ] = useState(props.item); 


    const minDate = new Date('1970-01-01')

    const toggle = () => {
        if (props.toggleButtonHandler) props.toggleButtonHandler();
    }

    useEffect(() =>{
        setItem(props.item);
        setIsOwner(props.item.type === 'Owner');
        switch (props.item.status) {
            case 'Active':
                setStatusClass('greenTag')
            break;
            case 'Deactivated':
                setStatusClass('redTag')
            break;
            case 'Invited':
                setStatusClass('yellowTag')
            break;
            default:

            break;
        }
        
    }, [props])

    return (
        <Fragment >
            <div className={styles.mainBarContainer}>
                <div className={styles.topSide}>
                    <button className={`standardButton ${styles.button}`} onClick={props.onBackHandler}>
                        <svg fill="#000000" height="15px" width="15px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 492" >
                            <g>
                                <g>
                                    <path d="M464.344,207.418l0.768,0.168H135.888l103.496-103.724c5.068-5.064,7.848-11.924,7.848-19.124
                                        c0-7.2-2.78-14.012-7.848-19.088L223.28,49.538c-5.064-5.064-11.812-7.864-19.008-7.864c-7.2,0-13.952,2.78-19.016,7.844
                                        L7.844,226.914C2.76,231.998-0.02,238.77,0,245.974c-0.02,7.244,2.76,14.02,7.844,19.096l177.412,177.412
                                        c5.064,5.06,11.812,7.844,19.016,7.844c7.196,0,13.944-2.788,19.008-7.844l16.104-16.112c5.068-5.056,7.848-11.808,7.848-19.008
                                        c0-7.196-2.78-13.592-7.848-18.652L134.72,284.406h329.992c14.828,0,27.288-12.78,27.288-27.6v-22.788
                                        C492,219.198,479.172,207.418,464.344,207.418z"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    {/* <button className={`standardButton ${styles.button}`} onClick={props.onBackHandler}>
                        Edit Team Member
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3785 8.44975L8.9636 17.8648C8.6844 18.144 8.3288 18.3343 7.94161 18.4117L4.99988 19.0001L5.58823 16.0583C5.66566 15.6711 5.85597 15.3155 6.13517 15.0363L15.5501 5.62132M18.3785 8.44975L19.7927 7.03553C20.1832 6.64501 20.1832 6.01184 19.7927 5.62132L18.3785 4.20711C17.988 3.81658 17.3548 3.81658 16.9643 4.20711L15.5501 5.62132M18.3785 8.44975L15.5501 5.62132" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button> */}
                </div>
                <div className={styles.info}>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Team Member Name</div>
                        <div className={styles.infoValue}>{`${item.firstName} ${item.lastName}`}</div>
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Role</div>
                        <div className={styles.infoValue}>{item.type ?? '/'}</div>
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Status</div>
                        <div className={styles[statusClass]}>{item.status ?? '/'}</div>
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Last login</div>
                        <div className={styles.infoValue}>{new Date(item.user.lastLogin) > minDate ? new Date(item.user.lastLogin).toLocaleDateString('en-US', options) : '/'}</div>
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Date created</div>
                        <div className={styles.infoValue}>{new Date(item.user.created).toLocaleDateString('en-US', options) ?? '/'}</div>
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Phone</div>
                        <div className={styles.infoValue}>
                            {item.user.phoneNumber && item.user.phoneNumber.trim() !== '' ? item.user.phoneNumber : '/'}
                            {item.user.phoneNumber && item.user.phoneNumber.trim() !== '' &&
                                <svg style={{cursor: 'pointer'}} onClick={() => navigator.clipboard.writeText(item.user.phoneNumber)} width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.05765 15.5C5.55252 15.5 5.12496 15.325 4.77498 14.975C4.42498 14.625 4.24998 14.1974 4.24998 13.6923V2.3077C4.24998 1.80257 4.42498 1.375 4.77498 1.025C5.12496 0.675 5.55252 0.5 6.05765 0.5H14.4422C14.9473 0.5 15.3749 0.675 15.7249 1.025C16.0749 1.375 16.2499 1.80257 16.2499 2.3077V13.6923C16.2499 14.1974 16.0749 14.625 15.7249 14.975C15.3749 15.325 14.9473 15.5 14.4422 15.5H6.05765ZM6.05765 14H14.4422C14.5191 14 14.5897 13.9679 14.6538 13.9038C14.7179 13.8397 14.7499 13.7692 14.7499 13.6923V2.3077C14.7499 2.23077 14.7179 2.16024 14.6538 2.09613C14.5897 2.03203 14.5191 1.99998 14.4422 1.99998H6.05765C5.98072 1.99998 5.9102 2.03203 5.8461 2.09613C5.78198 2.16024 5.74993 2.23077 5.74993 2.3077V13.6923C5.74993 13.7692 5.78198 13.8397 5.8461 13.9038C5.9102 13.9679 5.98072 14 6.05765 14ZM2.55768 18.9999C2.05256 18.9999 1.625 18.8249 1.275 18.4749C0.925 18.1249 0.75 17.6973 0.75 17.1922V4.3077H2.24998V17.1922C2.24998 17.2692 2.28202 17.3397 2.34613 17.4038C2.41024 17.4679 2.48076 17.5 2.55768 17.5H12.4422V18.9999H2.55768Z" fill="#1C1B1F"/>
                                </svg>
                            }
                        </div>
                        
                    </div>
                    <div className={styles.infoRow}>
                        <div className={styles.infoProperty}>Email address</div>
                        <div className={styles.infoValue}>{item.user?.username ?? '/'}
                        {item.user?.username != null && 
                            <svg style={{cursor: 'pointer'}} onClick={() => navigator.clipboard.writeText(item.user?.username)} width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.05765 15.5C5.55252 15.5 5.12496 15.325 4.77498 14.975C4.42498 14.625 4.24998 14.1974 4.24998 13.6923V2.3077C4.24998 1.80257 4.42498 1.375 4.77498 1.025C5.12496 0.675 5.55252 0.5 6.05765 0.5H14.4422C14.9473 0.5 15.3749 0.675 15.7249 1.025C16.0749 1.375 16.2499 1.80257 16.2499 2.3077V13.6923C16.2499 14.1974 16.0749 14.625 15.7249 14.975C15.3749 15.325 14.9473 15.5 14.4422 15.5H6.05765ZM6.05765 14H14.4422C14.5191 14 14.5897 13.9679 14.6538 13.9038C14.7179 13.8397 14.7499 13.7692 14.7499 13.6923V2.3077C14.7499 2.23077 14.7179 2.16024 14.6538 2.09613C14.5897 2.03203 14.5191 1.99998 14.4422 1.99998H6.05765C5.98072 1.99998 5.9102 2.03203 5.8461 2.09613C5.78198 2.16024 5.74993 2.23077 5.74993 2.3077V13.6923C5.74993 13.7692 5.78198 13.8397 5.8461 13.9038C5.9102 13.9679 5.98072 14 6.05765 14ZM2.55768 18.9999C2.05256 18.9999 1.625 18.8249 1.275 18.4749C0.925 18.1249 0.75 17.6973 0.75 17.1922V4.3077H2.24998V17.1922C2.24998 17.2692 2.28202 17.3397 2.34613 17.4038C2.41024 17.4679 2.48076 17.5 2.55768 17.5H12.4422V18.9999H2.55768Z" fill="#1C1B1F"/>
                            </svg>
                        }
                        </div>
                    </div>

                </div>
            </div>
            <div className={styles.bottomSection}>
                <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center'}} >
                    <div className={styles.botomText}>
                        Deactivate Agent
                    </div>
                    <ToggleButton onToggle={toggle} value={item.status === 'Deactivated'} isOwner={isOwner}/>
                </div>
            </div>
        </Fragment>
        
    )
})

export default SelectedListItem;
